import { DesignerPage } from './DesignerPage';

export default DesignerPage;
